import { useT } from "@/lib/i18n";

export type CaseMention = { outlet: string; url: string };
export type FamousCase = {
  slug: string;
  year: string;
  area: string;
  role: string;
  headline: string;
  summary: string;
  mentions: CaseMention[];
};

/**
 * Headline text and area/role labels flow through tk() so the backoffice can
 * translate or rephrase them. Press-mention URLs are factual references and
 * stay in code.
 */
export function useCases(): FamousCase[] {
  const { tk } = useT();
  return [
    {
      slug: "voyeur-probadores-sevilla",
      year: "2026",
      area: tk("cases.voyeur.area", "Derecho Penal"),
      role: tk("cases.voyeur.role", "Despacho a cargo de la defensa de una de las partes"),
      headline: tk(
        "cases.voyeur.headline",
        "Caso del voyeur que grabó a 94 mujeres en probadores de un centro comercial de Sevilla",
      ),
      summary: tk(
        "cases.voyeur.summary",
        "Una de las investigaciones penales con mayor repercusión mediática en Andalucía. RR Lex Juristas asume la defensa jurídica de una de las partes implicadas, garantizando un proceso ajustado a derecho y velando por la dignidad de las víctimas y los principios del debido proceso.",
      ),
      mentions: [
        {
          outlet: "Telecinco",
          url: "https://www.telecinco.es/noticias/andalucia/20260522/detenido-grabar-movil-mujeres-probadores-tiendas-sevilla_18_019236692.html",
        },
        {
          outlet: "Diario de Sevilla",
          url: "https://www.diariodesevilla.es/videos/video-detencion-voyeur-grabo-94-mujeres_8_2006828164.html",
        },
        {
          outlet: "La Voz del Sur",
          url: "https://www.lavozdelsur.es/ediciones/sevilla/94-mujeres-grabadas-desnudandose-en-probadores-de-un-centro-comercial-de-sevilla-el-presunto-autor-denunciado-tambien-por-agresion.html",
        },
        { outlet: "Facebook", url: "https://www.facebook.com/reel/968431846096542" },
        {
          outlet: "TikTok — El Tiempo Justo TV",
          url: "https://www.tiktok.com/@eltiempojustotv/video/7642373525315112214?_r=1&_t=ZN-96YYCGx2xxi",
        },
      ],
    },
    {
      slug: "trata-manicura-sevilla",
      year: "2025",
      area: tk("cases.trata.area", "Derecho Penal · Trata de seres humanos"),
      role: tk(
        "cases.trata.role",
        "Despacho a cargo de la representación letrada de una de las partes",
      ),
      headline: tk(
        "cases.trata.headline",
        "Liberación de 23 mujeres extranjeras explotadas en una red de salones de manicura",
      ),
      summary: tk(
        "cases.trata.summary",
        "Operación de la Policía Nacional con eco en prensa nacional que destapó una red de explotación laboral. RR Lex Juristas interviene en el procedimiento asumiendo la representación letrada de una de las partes implicadas en la causa.",
      ),
      mentions: [
        {
          outlet: "El País",
          url: "https://elpais.com/espana/catalunya/2025-05-24/liberadas-23-mujeres-extranjeras-explotadas-en-el-negocio-de-la-manicura-hasta-saldar-la-deuda-con-sus-captores.html",
        },
        {
          outlet: "Diario de Sevilla",
          url: "https://www.diariodesevilla.es/sevilla/policia-nacional-libera-23-victimas_0_2003998118.html",
        },
      ],
    },
  ];
}
